import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import FacebookLogin from '@greatsumini/react-facebook-login';
import '../pages/Login.css';
import AuthenticationProvider from '../providers/AuthenticationProvider';

const AuthLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showError, setShowError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  // Redirect if already logged in
  useEffect(() => {
    if (isLoggedIn) {
      navigate('/86sdk3fds97', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = async () => {
    try {
      const authProvider = new AuthenticationProvider();
      const result = await authProvider.checkAuthCredentials(username.trim(), password.trim());

      if (result?.token) {
        navigate('/86sdk3fds97', { state: { token: result.token }, replace: true });
      } else {
        setShowError(true);
      }
    } catch (err) {
      console.error('Login error:', err);
      setShowError(true);
    }
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const handleFacebookSuccess = async (response) => {
    console.log('Facebook login success:', response);
    try {
      const authProvider = new AuthenticationProvider();
      const result = await authProvider.checkAuthCredentials(response.email, 'facebook'); // adapt as needed
      if (result?.token) {
        navigate('/86sdk3fds97', { state: { token: result.token }, replace: true });
      } else {
        setShowError(true);
      }
    } catch (err) {
      console.error('FB login error:', err);
      setShowError(true);
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    console.log('Google login success:', credentialResponse);
    try {
      const authProvider = new AuthenticationProvider();
      const result = await authProvider.checkAuthCredentials(credentialResponse.credential, 'google'); // adapt as needed
      if (result?.token) {
        navigate('/86sdk3fds97', { state: { token: result.token }, replace: true });
      } else {
        setShowError(true);
      }
    } catch (err) {
      console.error('Google login error:', err);
      setShowError(true);
    }
  };

  const handleGoogleFailure = (err) => {
    console.error('Google login failure:', err);
    setShowError(true);
  };

  return (
    <GoogleOAuthProvider clientId="713906856141-9eg3bcch8a9lua79s214kluuef0thm9q.apps.googleusercontent.com">
      <div className="login-container">
        <h2>Login</h2>
        <form className="login-form">
          <label>
            Username:
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
          </label>
          <label>
            Password:
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          <div className="login-buttons">
            <button type="button" onClick={handleLogin}>
              Login
            </button>
            <button type="button" onClick={handleRegisterClick}>
              Register
            </button>
          </div>
        </form>

        {showError && (
          <div className="overlay">
            <div className="overlay-content">
              <h2>Login Error</h2>
              <p>Invalid username or password</p>
              <button onClick={() => setShowError(false)}>Close</button>
            </div>
          </div>
        )}

        {/* OAuth buttons */}
        <div className="platform-buttons">
          <FacebookLogin
            appId="1075421440241911"
            onSuccess={handleFacebookSuccess}
            onFail={(err) => {
              console.error('FB login error:', err);
              setShowError(true);
            }}
            onProfileSuccess={(response) => console.log('FB profile success:', response)}
            style={{
              backgroundColor: '#4267b2',
              color: '#fff',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer',
              margin: '5px',
            }}
          />

          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleFailure}
            theme="outline"
            size="large"
            width="250"
            style={{ margin: '5px auto', display: 'block' }}
          />
        </div>
      </div>
    </GoogleOAuthProvider>
  );
};

export default AuthLogin;
